import { fetchClient } from './services/fetchClient';
const getContextFramesRequest = async ({ language, userExperience, eTag, isLoggedIn, memberLocation, }) => {
    const url = new URL(`${process.env.PRIVACY_API_BASE_URL}/context_frames/v2/experience/${userExperience}/language/${language}`);
    const request = new Request(url.toString(), {
        headers: {
            ...(eTag && {
                'If-None-Match': eTag,
            }),
        },
    });
    return fetchClient({
        request,
        isLoggedIn,
        memberLocation,
    });
};
const getPurposeLimitationsMember = async ({ accessToken, userExperience, memberLocation, noCache, }) => {
    const headers = new Headers({
        Authorization: `Bearer ${accessToken}`,
        ...(noCache ? { 'Cache-Control': 'no-cache' } : {}),
    });
    const url = new URL(`${process.env.PRIVACY_API_BASE_URL}/purpose_limitations/v1`);
    url.search = new URLSearchParams({
        experience: userExperience,
    }).toString();
    const request = new Request(url.toString(), { headers });
    return fetchClient({
        request,
        isLoggedIn: true,
        memberLocation,
    });
};
const getPurposeLimitationsGuest = async ({ userExperience, guestLocation, }) => {
    const url = new URL(`${process.env.PRIVACY_API_BASE_URL}/purpose_limitation_defaults/v1/experience/${userExperience}/location/${guestLocation}`);
    return fetchClient({
        request: new Request(url.toString()),
        isLoggedIn: false,
        memberLocation: undefined,
    });
};
const updatePurposeLimitations = async ({ accessToken, userExperience, contextFrameToUpdateBody, contextFrameId, memberLocation, }) => {
    const headers = new Headers({
        Authorization: `Bearer ${accessToken}`,
    });
    const url = new URL(`${process.env.PRIVACY_API_BASE_URL}/consent/v2/context_frame/${contextFrameId}`);
    url.search = new URLSearchParams({
        experience: userExperience,
    }).toString();
    const request = new Request(url.toString(), {
        body: JSON.stringify(contextFrameToUpdateBody),
        headers,
        method: 'PUT',
    });
    return fetchClient({
        request,
        isLoggedIn: Boolean(accessToken),
        memberLocation,
    });
};
export { getContextFramesRequest, getPurposeLimitationsMember, getPurposeLimitationsGuest, updatePurposeLimitations, };
